export default __webpack_public_path__ + "static/media/onafriq.d262a867.jpg";